import { BoxProps, TextField } from "@mui/material"
import { DateTimePicker } from "@mui/x-date-pickers"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider/LocalizationProvider"
import { Dayjs } from "dayjs"
import React from "react"
import { useTranslation } from "react-i18next"
import { Box, Typography } from "src/UILibrary"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import "dayjs/locale/ja"

type Props = {
  sx?: BoxProps
  name?: string
  placeholder?: string
  required?: boolean
  datetime: Dayjs | null
  handleDateTime: any
  size?: number
  labelStyle?: any
  validationMessage?: string
  alignHorizontal?: boolean
  inputFormat?: string
  disabled?: boolean
}

const InputDateTimeField = ({
  sx,
  name,
  required,
  datetime,
  handleDateTime,
  size,
  labelStyle,
  validationMessage,
  alignHorizontal,
  inputFormat = "YYYY-MM-DD HH:mm:ss",
  disabled,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "base" })

  let style = sx || {}

  style = alignHorizontal
    ? { ...style, display: "flex", flexDirection: "row" }
    : { ...style, display: "flex", flexDirection: "column" }

  const customStyle = {
    "& ::before": {
      borderBottomColor: "#d4d3d7 !important",
    },
    "& .MuiInput-input": {
      fontSize: size,
    },
  }

  return (
    <>
      <Box
        sx={{
          ...style,
        }}
      >
        <Box display="flex" sx={alignHorizontal ? { my: "auto" } : { mb: "8px" }}>
          {name && (
            <Typography.DetailText sx={{ mr: "6px", ...labelStyle }}>{name}</Typography.DetailText>
          )}
          {required && (
            <Box
              sx={{
                px: "8px",
                borderWidth: "1px",
                borderStyle: "solid",
                borderRadius: "4px",
                borderColor: "text.border",
              }}
            >
              <Typography.InputFieldRequired sx={{ m: "auto", color: "text.border" }}>
                {t("required")}
              </Typography.InputFieldRequired>
            </Box>
          )}
        </Box>
        <Box display="flex">
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
              <DateTimePicker
                inputFormat={inputFormat}
                value={datetime}
                ampm={false}
                disabled={disabled}
                DialogProps={{
                  sx: { svg: { color: "#222222" }, span: { color: "#222222" } },
                }}
                PopperProps={{
                  sx: { svg: { color: "#222222" }, span: { color: "#222222" } },
                }}
                onChange={(newValue) => {
                  handleDateTime(newValue)
                }}
                renderInput={(params) => (
                  <TextField variant="standard" {...params} sx={{ ...customStyle }} />
                )}
              />
            </LocalizationProvider>
          </Box>
        </Box>
      </Box>
      {validationMessage && (
        <Box sx={{ height: "20px", pt: "5px" }}>
          <Typography.ValidationText>{validationMessage}</Typography.ValidationText>
        </Box>
      )}
    </>
  )
}

export default InputDateTimeField
